import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import QRCode from 'qrcode.react';
import React, { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { isAndroid, isIOS } from 'react-device-detect';
import styled from 'styled-components';

const EchoQRPage = () => {
  const navigate = useNavigate();
  const [qrUrl, setQrUrl] = useState<string>();
  const [tid, setTid] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const { t } = useTranslation();
  const { setPaymentState, setShopifyState } = usePaymentState();
  // 초기 시간 30초
  const initialTime = 30;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isMob, setIsMob] = useState(isMobile);

  const iosUrl = 'https://testflight.apple.com/join/JC98vYzD';
  const intentUrl = 'market://details?id=com.payverse';

  const appScheme =
    'payverse://qr/' +
    encodeURIComponent(
      window.location.search.substring(1) +
        `&lang=${sessionStorage.getItem('i18nextLng')}&isMob=true`,
    );

  const updatePaymentState = infoData => {
    setPaymentState(prevState => ({
      ...prevState,
      requestCurrency: infoData.display.requestCurrency,
      requestAmount: infoData.display.requestAmount,
      reqDate: infoData.display.responseDatetime,
      orderId: infoData.response.orderId,
      resultCode: infoData.response.resultCode,
      resultMessage: infoData.response.resultMessage,
      mallReserved: infoData.response.mallReserved,
      billKey: infoData.response.billKey,
      schemeGroup: infoData.response.schemeGroup,
      schemeCode: infoData.response.schemeCode,
    }));
  };

  //InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      const resultStat = data.data.response.resultStatus;
      // 응답 pending 아니면 SelfClose
      if (
        resultStat !== null &&
        String(resultStat).toLowerCase() !== 'pending'
      ) {
        if (isMobile) {
          if (data.data.returnUrl.includes('shopifyConfirm')) {
            setShopifyState(data.data.response);

            navigate('/shopifyConfirm');
          } else {
            updatePaymentState(data.data);
            payResult(data);
          }
        } else {
          window.close();
        }
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const pollingEndTransactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      if (data.data.returnUrl.includes('shopifyConfirm')) {
        setShopifyState(data.data.response);

        navigate('/shopifyConfirm');
      } else {
        // PaymentState Set
        updatePaymentState(data.data);
        // InnerSearch 결과처리
        payResult(data);
        // 상태코드 예외처리
        if (
          data.data.response.resultStatus === null ||
          data.data.response.resultStatus === undefined
        ) {
          navigate('/error');
        }
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const payResult = data => {
    // 결과 상태
    const resultStatus = String(data.data.response.resultStatus).toLowerCase();
    // 결제 타입
    const payType = String(data.data.display.payType).toLowerCase();
    // InnerSearch 결과 값 PaymentState 설정
    setPaymentState(prevState => ({
      ...prevState,
      resultCode: data.data.response.resultCode,
      resultMessage: data.data.response.resultMessage,
      tid: data.data.response.tid,
      orderId: data.data.response.orderId,
      mallReserved: data.data.response.mallReserved,
      billKey: data.data.response.billKey,
      returnUrl: data.data.returnUrl,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));
    // Status에 따른 Paging 처리
    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        payType === 'vbank' || payType === 'otc'
          ? navigate('/vbankPending')
          : navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tidStr = urlParams.get('tid');
    if (tidStr !== null) {
      setTid(tidStr);
    }
    const appSchemeString =
      'payverse://qr/' +
      encodeURIComponent(
        window.location.search.substring(1) +
          `&lang=${sessionStorage.getItem('i18nextLng')}`,
      );
    setQrUrl(appSchemeString);

    if (isIOS) window.location.replace(appScheme);
  }, []);

  useEffect(() => {
    if (qrUrl && qrUrl !== undefined) {
      setLoading(false);
    }
  }, [qrUrl]);

  useEffect(() => {
    let polling = setInterval(() => {
      transactResult.mutate();
    }, 3000);

    setTimeout(() => {
      clearInterval(polling);
      if (isMobile) {
        pollingEndTransactResult.mutate();
      } else {
        window.close();
      }
    }, 30000);

    return () => {
      clearInterval(polling);
    };
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  };

  if (isMob)
    return (
      <div style={{ height: 'calc(100% - 90px)' }}>
        {isAndroid && (
          <div>
            <Header>{t('run_payverse_app')}</Header>
            <BtnContainer>
              <button
                onClick={() => {
                  window.location.replace(appScheme);
                }}
              >
                {t('pay_in_app')}
              </button>
              <button
                onClick={() => {
                  window.location.href = intentUrl;
                }}
              >
                {t('aos_install')}
              </button>
              <button
                onClick={() => {
                  setIsMob(false);
                  setTimeLeft(30);
                }}
              >
                QR OPEN
              </button>
            </BtnContainer>
          </div>
        )}
        {isIOS && (
          <div>
            <Header> {t('opening_payverse_app')}</Header>
            <BtnContainer>
              <button onClick={() => window.location.replace(iosUrl)}>
                {t('ios_install')}
              </button>
              <button
                onClick={() => {
                  setIsMob(false);
                  setTimeLeft(30);
                }}
              >
                QR OPEN
              </button>
            </BtnContainer>
          </div>
        )}
      </div>
    );

  return (
    <div style={{ height: 'calc(100% - 90px)' }}>
      <div
        style={{
          flexDirection: 'column',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {loading ? (
          <LoadingIndicator />
        ) : (
          qrUrl && (
            <>
              <div
                className="title"
                style={{
                  marginBottom: 50,
                  fontSize: 18,
                  backgroundColor: '#163b6a',
                  color: '#FFFFFF',
                  padding: '10px 40px',
                  borderRadius: 10,
                }}
              >
                QR Code Form
              </div>
              <div
                style={{
                  border: '2px solid #163b6a',
                  padding: '10px 10px 5px 10px',
                  borderRadius: 10,
                }}
              >
                <QRCode
                  value={qrUrl}
                  style={{ width: '180px', height: '180px' }}
                />
              </div>
              <div
                className="title"
                style={{
                  marginTop: 10,
                  fontSize: 18,
                  // backgroundColor: '#163b6a',
                  // color: '#FFFFFF',
                  padding: '10px 40px',
                  borderRadius: 10,
                }}
              >
                {t('scan_qr_code')} {formatTime(timeLeft)}
              </div>
              <div
                className="title"
                style={{
                  marginTop: 10,
                  fontSize: 18,
                  padding: '10px 40px',
                  borderRadius: 10,
                  color: 'gray',
                }}
              >
                {t('scan_qr_code_expires')}
              </div>
            </>
          )
        )}
      </div>
    </div>
  );
};

export default EchoQRPage;

const Header = styled.p`
  text-align: center;
  padding: 50px 0px;
  font-size: 18px;
`;

const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  button {
    width: 250px;
    height: 40px;
  }
`;
